// Descritor sem render: o Root o converte em `model` do Menu via `toItem`; o nome `view-` é exigência do contrato de estrutura.
import { TABLE_ACTIONS_SETTINGS_LABEL } from "../messages";
import type { ItemProps, ShortcutItemProps } from "../types-table-actions-menu";

/** "Configurações da Tabela" (GLOSSARIO.md, "Listagens"); testId `<testId do Root>-settings`. */
export function TableActionsMenuSettingsItem(props: ShortcutItemProps): null {
  void props;
  return null;
}
TableActionsMenuSettingsItem.displayName = "TableActionsMenu.SettingsItem";
TableActionsMenuSettingsItem.toItem = (
  props: ShortcutItemProps,
  partTestId: (part: string) => string | undefined,
): ItemProps => ({
  ...props,
  label: TABLE_ACTIONS_SETTINGS_LABEL,
  icon: "cog",
  testId: partTestId("settings"),
});
